import { loyaltyHowItWorks } from '@/mocks/loyalty';

const LoyaltyHowItWorks = () => {
  return (
    <section className="py-20 px-4 md:px-8 lg:px-12" style={{ background: '#050508' }}>
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="text-center mb-14">
          <p className="font-mono text-xs tracking-[0.3em] mb-2" style={{ color: '#39ff14' }}>КАК ЭТО РАБОТАЕТ</p>
          <h2 className="font-orbitron font-black text-3xl md:text-4xl text-white mb-3">
            ПОЛУЧАТЬ БАЛЛЫ ЛЕГКО
          </h2>
          <p className="font-mono text-sm text-white/40 max-w-xl mx-auto">
            Четыре простых шага до первой экономии с бонусной картой NEON PHARMA
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-16 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.08) 20%, rgba(255,255,255,0.08) 80%, transparent)' }} />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {loyaltyHowItWorks.map((step, i) => (
              <div key={i} className="flex flex-col items-center text-center relative group">
                {/* Step number bubble */}
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center mb-5 relative z-10 transition-all duration-300 group-hover:scale-110"
                  style={{
                    background: `${step.color}15`,
                    border: `2px solid ${step.color}`,
                    boxShadow: `0 0 20px ${step.color}30`,
                  }}
                >
                  <i className={step.icon} style={{ color: step.color, fontSize: '22px' }} />
                  <div
                    className="absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center font-orbitron font-black text-[10px]"
                    style={{ background: step.color, color: '#050508' }}
                  >
                    {step.step}
                  </div>
                </div>

                <h3 className="font-orbitron font-bold text-sm text-white mb-2">{step.title}</h3>
                <p className="font-mono text-xs text-white/45 leading-relaxed">{step.description}</p>

                {/* Arrow between steps */}
                {i < loyaltyHowItWorks.length - 1 && (
                  <div className="hidden lg:flex absolute top-16 -right-3 z-20 w-6 h-6 items-center justify-center">
                    <i className="ri-arrow-right-line text-white/20 text-sm" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* App promo block */}
        <div
          className="mt-16 rounded-2xl overflow-hidden relative"
          style={{ border: '1px solid rgba(57,255,20,0.2)', background: 'rgba(57,255,20,0.03)' }}
        >
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full opacity-5" style={{ background: '#39ff14', filter: 'blur(60px)', transform: 'translate(30%, -30%)' }} />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full font-mono text-xs mb-4" style={{ background: 'rgba(57,255,20,0.1)', border: '1px solid rgba(57,255,20,0.25)', color: '#39ff14' }}>
                <i className="ri-smartphone-line" />
                МОБИЛЬНОЕ ПРИЛОЖЕНИЕ
              </div>
              <h3 className="font-orbitron font-black text-2xl text-white mb-3">
                Получайте баллы<br />
                <span style={{ color: '#39ff14' }}>ещё быстрее</span>
              </h3>
              <p className="font-mono text-sm text-white/50 leading-relaxed mb-6">
                Получите виртуальную карту при регистрации в приложении. Показывайте штрихкод при покупках — баллы начисляются автоматически. Золотой уровень даёт +5% за заказы через приложение.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  className="whitespace-nowrap flex items-center gap-2 px-5 py-3 rounded-xl font-mono text-xs cursor-pointer transition-all duration-300"
                  style={{ background: 'rgba(57,255,20,0.1)', border: '1px solid rgba(57,255,20,0.3)', color: '#39ff14' }}
                >
                  <i className="ri-apple-line text-base" />
                  App Store
                </button>
                <button
                  className="whitespace-nowrap flex items-center gap-2 px-5 py-3 rounded-xl font-mono text-xs cursor-pointer transition-all duration-300"
                  style={{ background: 'rgba(57,255,20,0.1)', border: '1px solid rgba(57,255,20,0.3)', color: '#39ff14' }}
                >
                  <i className="ri-google-play-line text-base" />
                  Google Play
                </button>
              </div>
            </div>

            {/* Phone mockup */}
            <div className="flex justify-center lg:justify-end">
              <div
                className="w-52 rounded-3xl p-4 relative"
                style={{ background: '#0a0a14', border: '2px solid rgba(57,255,20,0.3)', boxShadow: '0 0 40px rgba(57,255,20,0.15)' }}
              >
                {/* Phone screen */}
                <div className="rounded-2xl overflow-hidden" style={{ background: '#050508', border: '1px solid rgba(255,255,255,0.06)' }}>
                  <div className="p-4">
                    <div className="font-mono text-[9px] text-white/30 mb-1">NEON PHARMA</div>
                    <div className="font-orbitron font-black text-2xl mb-0.5" style={{ color: '#39ff14', textShadow: '0 0 10px rgba(57,255,20,0.8)' }}>1 248</div>
                    <div className="font-mono text-[10px] text-white/40 mb-4">бонусных баллов</div>

                    {/* Barcode */}
                    <div className="flex gap-0.5 justify-center mb-3">
                      {Array.from({ length: 28 }).map((_, i) => (
                        <div
                          key={i}
                          className="rounded-sm"
                          style={{
                            width: i % 3 === 0 ? '3px' : '1.5px',
                            height: '40px',
                            background: '#39ff14',
                            opacity: 0.7 + Math.random() * 0.3,
                          }}
                        />
                      ))}
                    </div>
                    <div className="font-mono text-[9px] text-white/25 text-center">**** **** **** 1337</div>

                    <div className="mt-4 p-2 rounded-lg" style={{ background: 'rgba(57,255,20,0.08)', border: '1px solid rgba(57,255,20,0.2)' }}>
                      <div className="font-mono text-[9px] text-white/40 mb-0.5">Уровень</div>
                      <div className="font-orbitron font-bold text-xs" style={{ color: '#39ff14' }}>STANDARD</div>
                      <div className="mt-1.5 h-1 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.05)' }}>
                        <div className="h-full rounded-full" style={{ width: '62%', background: '#39ff14', boxShadow: '0 0 6px #39ff14' }} />
                      </div>
                      <div className="font-mono text-[8px] text-white/25 mt-0.5">До GOLD: 8 752 ₽</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoyaltyHowItWorks;
